import React, { useEffect } from 'react';
import { PageLayout } from '../../components/page/page-layout';
import { TextLarge } from '../../components/text';
import { columns } from './columns';
import { useSelector } from 'react-redux';
import { useGetScanHistory } from './hooks/useGetScanHistory';
import { Spin } from 'antd';

export const ScanHistory = () => {
  const { employeeId } = useSelector((state) => state.info);

  const {
    mutate: scanHistory,
    data: scanHistoryData,
    isPending: loadingHistory,
  } = useGetScanHistory();

  useEffect(() => {
    if (employeeId) {
      scanHistory(employeeId);
    }
  }, [employeeId]);

  return (
    <Spin spinning={loadingHistory}>
      <TextLarge
        text="ประวัติการสแกน"
        style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      />
      <PageLayout
        tableLayout={{
          columns: columns() || [],
          dataSource: scanHistoryData?.result?.history || [],
          hasPagination: true,
        }}
      />
    </Spin>
  );
};
